import COLOR from './color';

export const DIVIDER_BORDER_TOP = `1px solid ${COLOR.GRAY_200}`;
